document.addEventListener('DOMContentLoaded', function () {
 
  // Toggle dropdown
  document.body.addEventListener('click', function(e) {
 
    const toggle = e.target.closest('[data-disclosure-toggle]');
    if (toggle) {
      e.preventDefault();
 
      const disclosure = toggle.closest('.disclosure');
 
      // close all others
      document.querySelectorAll('.disclosure').forEach(function(item) {
        if (item !== disclosure) {
          item.classList.remove('is-open');
        }
      });
 
      disclosure.classList.toggle('is-open');
    }
 
    // Select option
    const option = e.target.closest('[data-disclosure-option]');
    if (option) {
      e.preventDefault();
 
      const form = option.closest('form');
      const input = form.querySelector('[data-disclosure-input]');
      input.value = option.dataset.value;
 
      form.submit();
    }
 
    // Click outside → close
    if (!e.target.closest('.disclosure')) {
      document.querySelectorAll('.disclosure').forEach(function(item) {
        item.classList.remove('is-open');
      });
    }
 
  });
 
});
$('.video_wrapper__around').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.video-text-around').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
});


$('.coll__listing').slick({
  dots: false,
  arrows:true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        infinite: true
      }
    }
  ]
});

$( document ).ready(function() {
  $('.template-product').find('.prod_description button').click();
  $('.template-collection').find('.grid__item--sidebar .collection-sidebar__group--2 button').click(); 
  $('.collection-filter__btn').click(function(){
    $('.collection-filter__item--right ul').toggleClass('hide');
  });
});



 